import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#72FFCC",
      d: "M8.5 0A8.497 8.497 0 0 0 0 8.5C0 13.197 3.803 17 8.5 17S17 13.197 17 8.5A8.5 8.5 0 0 0 8.5 0M7.059 13.372a.88.88 0 0 1-1.245 0l-3.41-3.649a.92.92 0 0 1 0-1.303.92.92 0 0 1 1.303 0l2.761 2.942 6.83-6.835a.92.92 0 0 1 1.303 0 .92.92 0 0 1 0 1.303z"
    }, null, -1)
  ]))]))
}
export default { render: render }